module.exports = __webpack_public_path__ + "static/img/pv.98e8d8ea.svg";